// ProfileContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';

const ProfileContext = createContext();

export const ProfileProvider = ({ children }) => {
  const [selectedProfileId, setSelectedProfileId] = useState(() => {
    // Essayez de récupérer l'ID du profil à partir du stockage local lors de la première initialisation
    const storedId = sessionStorage.getItem('selectedProfileId');
    return storedId ? storedId : null;
  });

  const selectProfile = (id) => {
    setSelectedProfileId(id);
  };

  // Mettez à jour le stockage local à chaque changement de l'ID du profil
  useEffect(() => {
    sessionStorage.setItem('selectedProfileId', selectedProfileId);
  }, [selectedProfileId]);

  return (
    <ProfileContext.Provider value={{ selectedProfileId, selectProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};

export const useProfile = () => {
  return useContext(ProfileContext);
};
